import React from 'react'
import useStore from '../../../../ProductStore/Store'
import uploadIcon from '../../../../../img/uploadSVG.svg'
import styles from './styles.module.css'

function FirstRowBoxes () {
  const {
    isQueryLoading,
    setBrandManufacturer,
    setRequiredFields,
    setDomain,
    setTaxonomyLevel1,
    setMostRecentPriceIsSale
  } = useStore()

  const onClickSearchSpecificBrand = () => {
    if (isQueryLoading) return
    setBrandManufacturer('Samsung')
  }
  const onClickAmazonProducts = () => {
    if (isQueryLoading) return

    setRequiredFields(['asins', 'mostRecentPriceAmount'])
    setDomain('amazon.com')
  }

  const onClickCurrentlyOnSaleAppliances = () => {
    if (isQueryLoading) return
    setTaxonomyLevel1('appliances')
    setMostRecentPriceIsSale('true')
  }

  return (
    <section>
      <div className={styles.FirstRowBoxesContainer}>
        <h2 className={styles.FirstRowBoxesTitle}>Search example</h2>
        <div className={styles.FirstRowBoxesValues}>
          <div
            className={`${styles.FirstRowBoxesItem} ${
              isQueryLoading ? styles.FirstRowBoxesItemDisabled : ''
            }`}
            onClick={onClickSearchSpecificBrand}
          >
            <div>
              <span className={styles.FirstRowBoxesSpan}>
                Search specific brand
              </span>

              <p className={styles.FirstRowBoxesText}>
                Search for Samsung as a brand
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.FirstRowBoxesImg}
            />
          </div>
          <div
            className={`${styles.FirstRowBoxesItem} ${
              isQueryLoading ? styles.FirstRowBoxesItemDisabled : ''
            }`}
            onClick={onClickAmazonProducts}
          >
            <div>
              <span className={styles.FirstRowBoxesSpan}>
                Search for amazon products
              </span>
              <p className={styles.FirstRowBoxesText}>
                Search for amazon-specific products with ASINs
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.FirstRowBoxesImg}
            />
          </div>
          <div
            className={`${styles.FirstRowBoxesItem} ${
              isQueryLoading ? styles.FirstRowBoxesItemDisabled : ''
            }`}
            onClick={onClickCurrentlyOnSaleAppliances}
          >
            <div>
              <span className={styles.FirstRowBoxesSpan}>
                Currently on sale appliances
              </span>
              <p className={styles.FirstRowBoxesText}>
                Search for currently on sale appliances.
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.FirstRowBoxesImg}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default FirstRowBoxes
